// extracted by mini-css-extract-plugin
export var controls = "hosted-video-module--controls--26d86";
export var hoverplayThumbnail = "hosted-video-module--hoverplayThumbnail--d97a0";
export var loaded = "hosted-video-module--loaded--d99e8";
export var testimonialQuote = "hosted-video-module--testimonialQuote--c8932";
export var testimonialWrapper = "hosted-video-module--testimonialWrapper--0264a";